import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { MatTableDataSource } from '@angular/material/table';
import { ContainerReturnService } from '../../../services/container-return/container-return.service';
import * as $ from 'jquery';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-container-returns-confirmation',
  templateUrl: './container-returns-confirmation.component.html',
  styleUrls: ['./container-returns-confirmation.component.scss']
})
export class ContainerReturnsConfirmationComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Subscription();

  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  shipToAccountItems: any[];
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  searchValue = '';
  partialSearchValue = '';
  invoiceNumberList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'returnType', 'itemNumber', 'serialNumber', 'requestedUnits', 'uom', 'packageSize', 'notes'];
  isParent = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  shipToDataLoading = true;
  index: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;

  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;

  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  showScaleDelete = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete = false;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending = true;;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  selectedProductLineValue: string;
  selectedProductLineId: string;

  desiredPickupDate: any;
  contactName: string;
  contactNumber: string;
  customerPONumber = 'Return';
  shippingInstructions: string;
  selectedFreightInstruction: string;
  selectedFreightInstructionName: string;
  palletCount: number;
  soldToFacility: any[];
  soldToAccount: number;
  shipToAddress: string;
  soldToaccountName: string;
  soldToaddress: string;
  shipToAcnumber: string;
  soldToAcnumber: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    public containerReturnsService: ContainerReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.containerReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestId']) {
              this.returnRequestId = +x['returnRequestId'];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    this.productAllDataSource = new MatTableDataSource([]);
    this.containerReturnsService.setEditModeStatus(false);
    this.errorMsgs = new Array();
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnsService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = 'Return Request [' + result.returnRequestNumber + ']';
      this.containerReturnsService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.containerReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.containerReturnsProductList && result.containerReturnsProductList.length > 0) {
        result.containerReturnsProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if (!this.isApprovalAccess && x.lineStatus == 'PENDING') {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == 'APPROVED') {
            x.isIncreaseQtyDisable = true;
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.containerReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.containerReturnsService.setProductList(result.containerReturnsProductList);
      this.bindDataSource(result.containerReturnsProductList, true);
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.containerReturnsService.setSelectedAccountNo(result.shipToAccountId);
      const approvedItem = result.containerReturnsProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.shipToAddress = result.shipToAccount.address1;
      this.soldToaccountName = result.soldToAccount.accountName;
      this.soldToaddress = result.soldToAccount.address1;
      this.soldToAcnumber = result.soldToAccount.accountNumber;
      this.shipToAcnumber = result.shipToAccount.accountNumber;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.containerReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;

        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem && requestItem.length > 0) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  backToReturnList() {
    this.router.navigate(['/container-returns/dashboard-products']);
  }

  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
